var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col announce-sec" }),
      _vm._v(" "),
      _c("div", { staticClass: "col content" }, [
        _c("div", { staticClass: "login-form-sec" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "login-content" }, [
            _vm.step === 1
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.checkIsEmailVerified.apply(null, arguments)
                      }
                    }
                  },
                  [
                    !_vm.passErrValid && _vm.display.login_error
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-danger",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.display.login_error) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.passErrValid && _vm.display.login_error
                      ? _c(
                          "div",
                          {
                            staticClass: "alert alert-success",
                            attrs: { role: "alert" }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.display.login_error) +
                                "\n              "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.otpSent
                      ? _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "has-error": _vm.errors.has("email") }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "control-label visible-ie8 visible-ie9"
                              },
                              [_vm._v("Username")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-icon" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.form.username,
                                    expression: "form.username"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required|email",
                                    expression: "'required|email'"
                                  }
                                ],
                                ref: "email",
                                class:
                                  "form-control" +
                                  (_vm.getError("email") ? " txterror" : ""),
                                attrs: {
                                  type: "email",
                                  name: "email",
                                  placeholder: "Email",
                                  disabled: _vm.otpSent
                                },
                                domProps: { value: _vm.form.username },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.form,
                                      "username",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.errors.has("email") && _vm.form.username
                              ? _c("span", { staticClass: "error" }, [
                                  _vm._v("Please enter a valid email address.")
                                ])
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.otpSent
                      ? _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "has-error": _vm.errors.has("password") }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "control-label visible-ie8 visible-ie9"
                              },
                              [_vm._v("Password")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "input-icon" }, [
                              (_vm.showPassword ? "text" : "password") ===
                              "checkbox"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.password,
                                        expression: "form.password"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    ref: "password",
                                    class:
                                      "form-control" +
                                      (_vm.getError("password")
                                        ? " txterror"
                                        : ""),
                                    attrs: {
                                      disabled: _vm.otpSent,
                                      name: "password",
                                      placeholder: "Password",
                                      type: "checkbox"
                                    },
                                    domProps: {
                                      checked: Array.isArray(_vm.form.password)
                                        ? _vm._i(_vm.form.password, null) > -1
                                        : _vm.form.password
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.form.password,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.form,
                                                "password",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.form,
                                                "password",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(_vm.form, "password", $$c)
                                        }
                                      }
                                    }
                                  })
                                : (_vm.showPassword ? "text" : "password") ===
                                  "radio"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.password,
                                        expression: "form.password"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    ref: "password",
                                    class:
                                      "form-control" +
                                      (_vm.getError("password")
                                        ? " txterror"
                                        : ""),
                                    attrs: {
                                      disabled: _vm.otpSent,
                                      name: "password",
                                      placeholder: "Password",
                                      type: "radio"
                                    },
                                    domProps: {
                                      checked: _vm._q(_vm.form.password, null)
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.$set(
                                          _vm.form,
                                          "password",
                                          null
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.form.password,
                                        expression: "form.password"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    ref: "password",
                                    class:
                                      "form-control" +
                                      (_vm.getError("password")
                                        ? " txterror"
                                        : ""),
                                    attrs: {
                                      disabled: _vm.otpSent,
                                      name: "password",
                                      placeholder: "Password",
                                      type: _vm.showPassword
                                        ? "text"
                                        : "password"
                                    },
                                    domProps: { value: _vm.form.password },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.form,
                                          "password",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                              _vm._v(" "),
                              !_vm.showPassword
                                ? _c("img", {
                                    staticClass: "eye-icon",
                                    attrs: {
                                      src: "/static/images/eye.svg",
                                      alt: "Show Password"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showPassword
                                ? _c("img", {
                                    staticClass: "eye-icon",
                                    attrs: {
                                      src: "/static/images/eye-off.svg",
                                      alt: "Hide Password"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.showPassword = !_vm.showPassword
                                      }
                                    }
                                  })
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-actions" }, [
                      !_vm.otpSent
                        ? _c(
                            "button",
                            {
                              staticClass: "btn b-btn red-btn",
                              attrs: {
                                type: "submit",
                                id: "sendOtpBtn",
                                disabled: _vm.waiting
                              }
                            },
                            [
                              _c("span", { attrs: { disabled: _vm.waiting } }, [
                                _vm._v("Login")
                              ])
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.otpSent && _vm.$route.query.step == "verify-otp"
                      ? _c(
                          "div",
                          {
                            staticClass: "form-group",
                            class: { "has-error": _vm.errors.has("otpcode") }
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "control-label visible-ie8 visible-ie9"
                              },
                              [_vm._v("Enter OTP")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.form.otpcode,
                                  expression: "form.otpcode"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              ref: "otpcode",
                              staticClass: "otp-input form-control",
                              class: _vm.getError("otpcode") ? "txterror" : "",
                              attrs: {
                                type: "text",
                                minlength: "4",
                                maxlength: "4",
                                name: "otpcode",
                                id: "otpcode",
                                placeholder: "Enter OTP",
                                pattern: "\\d*"
                              },
                              domProps: { value: _vm.form.otpcode },
                              on: {
                                keypress: [
                                  _vm.onlyNumbers,
                                  function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.entSub(_vm.form)
                                  }
                                ],
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.form,
                                    "otpcode",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.otpSent
                      ? _c("div", { staticClass: "form-actions" }, [
                          _vm.otpSent
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn b-btn red-btn",
                                  staticStyle: { float: "left" },
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.waiting
                                  },
                                  on: { click: _vm.loginAction }
                                },
                                [_vm._v("Login\n                ")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: "javascript:void(0)" },
                              on: { click: _vm.resendOtp }
                            },
                            [_vm._v("Resend OTP")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.otpSent
                      ? _c("div", { staticClass: "row" }, [_vm._m(1)])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.otpSent
                      ? _c("div", { staticClass: "forget-password" }, [
                          _c("p", { staticClass: "m-0" }, [
                            _c(
                              "a",
                              {
                                staticStyle: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.showForget()
                                  }
                                }
                              },
                              [_vm._v("Forgot your password ?")]
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.step === 2 && !_vm.otpSent
              ? _c("form", [
                  _vm.display.error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" }
                        },
                        [_vm._v(_vm._s(_vm.display.error))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h5", { staticClass: "form-title" }, [
                    _vm._v("FORGOT YOUR PASSWORD11 ?")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Enter the email that is registered to your account below to reset your password."
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "input-icon" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.form.username,
                            expression: "form.username"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|email",
                            expression: "'required|email'"
                          }
                        ],
                        ref: "email",
                        staticClass: "form-control",
                        attrs: {
                          type: "email",
                          name: "email",
                          placeholder: "Email"
                        },
                        domProps: { value: _vm.form.username },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.form, "username", $event.target.value)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _vm.errors.count() > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "text-danger",
                            staticStyle: { "margin-top": "15px" }
                          },
                          [_vm._v("Please enter a valid email address.")]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-actions f-btn" }, [
                    _c(
                      "a",
                      {
                        staticClass: "white-btn float-left",
                        on: { click: _vm.hideForget }
                      },
                      [_vm._v("Go to Login ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "b-btn red-btn",
                        attrs: {
                          type: "button",
                          disabled:
                            _vm.errors.count() > 0 || _vm.waiting == true
                        },
                        on: {
                          click: function($event) {
                            return _vm.forgetAction()
                          }
                        }
                      },
                      [_vm._v("Submit\n                ")]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.display.success
                    ? _c(
                        "h6",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "font-weight": "bold"
                          }
                        },
                        [
                          _c("i", { staticClass: "fa fa-check" }),
                          _vm._v(" " + _vm._s(_vm.display.success))
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copyright" }, [
            _vm._v("B1G1 © " + _vm._s(new Date().getFullYear()))
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("a", { attrs: { href: "https://www.b1g1.com" } }, [
        _c("link", {
          attrs: {
            rel: "stylesheet",
            media: "all",
            type: "text/css",
            href: "/static/front/font_css.css"
          }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "logo-default",
          attrs: { src: "/static/logos/logo.png", alt: "alt" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "dont-sec" }, [
      _c("p", [
        _vm._v("Don't have an account?"),
        _c("br"),
        _c("a", { attrs: { href: "https://family.b1g1.com/get-started" } }, [
          _vm._v("Create an account")
        ]),
        _vm._v(" or "),
        _c("a", { attrs: { href: "https://b1g1.com/family/home" } }, [
          _vm._v("learn more here")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 